module.exports = __webpack_public_path__ + "img/主题.146f2747.svg";